import { reqF } from "./axiosFun";

// 获取系统错误日志分页列表
export const GetSystemErrorLogList = (params) => {
	return reqF("post", "/api/sysConfig/SystemErrorLog/GetSystemErrorLogList", params);
};
// 获取系统错误日志详情
export const GetSystemErrorLogByKeyId = (params) => {
	return reqF("post", "/api/sysConfig/SystemErrorLog/GetSystemErrorLogByKeyId", params);
};
// 批量删除系统错误日志
export const DeleteSystemErrorLog = (params) => {
	return reqF("post", "/api/sysConfig/SystemErrorLog/DeleteSystemErrorLog", params);
};
